<input type="text" [placeholder]="_placeholder" [formControl]="_formControl" [matAutocomplete]="auto"
  class="form-control" />
<mat-autocomplete #auto="matAutocomplete" [displayWith]="getTitle.bind(this)">
  <mat-option *ngFor="let item of _listFiltered | async; " [value]="item">
    {{ fullTitle ? item.id + ' - ' + item.descrizione : item.descrizione }}
  </mat-option>
</mat-autocomplete>
@if(_formControl.errors?.['required'] && _formControl.touched){
  <div class="invalid-feedback">Il campo è obbligatorio</div>
}
@if((!_formControl.errors?.['required'] && _formControl.errors?.['incorrect']) && _formControl.touched){
  <div class="invalid-feedback">Il campo non è valido</div>
}
